import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {AuthorizationService} from './authorization.service';
import { Campaign, AgentCampaign } from '../models/campaign';
import {environment} from '../environments/enviroment';


@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  private baseUrl = `${environment.mindxbkUrl}campaign`;

  private campaigns_subject: BehaviorSubject<Campaign[]> = new BehaviorSubject<Campaign[]>([]);
  campaigns$: Observable<Campaign[]> = this.campaigns_subject.asObservable();

  constructor(
    private http: HttpClient,
    private authService: AuthorizationService
  ) {
  }

  getCampaigns(ids?: string[]): Observable<Campaign[]> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const url = `${this.baseUrl}/list`;
    const body = {ids: ids ?? null};

    return this.http.post<Campaign[]>(url, body, {headers});
  }

  getCampaignsByWorkspaceId(workspaceId: string): Observable<Campaign[]> {
    // Leer el token desde localStorage
    const token = localStorage.getItem('auth_req');
    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const url = `${this.baseUrl}/get_campaigns_workspace`;
    const data = {
      workspace_id: workspaceId
    };

    return this.http.post<Campaign[]>(url, data, {headers});
  }

  createCampaign(campaign: Partial<Campaign>): Observable<Campaign> {
    const token = localStorage.getItem('auth_req');

    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    });

    return this.http.post<Campaign>(`${this.baseUrl}/create`, campaign, { headers });
  }

  getCampaignById(id: string): Observable<Campaign> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<Campaign>(`${this.baseUrl}/${id}`, { headers });
  }

  updateCampaignById(id: string, campaign: Partial<Campaign>): Observable<Campaign> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    });

    return this.http.put<Campaign>(`${this.baseUrl}/${id}`, campaign, { headers });
  }

  /*
    * Remove a campaign by its ID.
    * @param id - The ID of the campaign to remove.
    * @returns An Observable that emits when the campaign is successfully removed.
    * The api return 200 status code on success.
    * If the campaign does not exist, it returns a 404 status code.
  */
  removeCampaignById(id: string): Observable<void> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.delete<void>(`${this.baseUrl}/${id}`, { headers });
  }
  setCampaignsStorage(campaigns: Campaign[]) {
    //console.log('CampaignService.setCampaigns:', campaigns);
    this.campaigns_subject.next(campaigns);
  }

  getCampaignsFromStorage(): Campaign[] {
    const campaignsData = localStorage.getItem('campaigns');
    return campaignsData ? JSON.parse(campaignsData) : [];
  }

  clearCampaignsStorage() {
    localStorage.removeItem('campaigns');
    this.campaigns_subject.next([]);
  }

  updateCampaignAgentPriority(campaignId: string, agents: AgentCampaign[]): Observable<Campaign> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const url = `${this.baseUrl}/update_priority_agents/${campaignId}`;
    return this.http.patch<Campaign>(url, agents, { headers });
  }

}
